import { BaseApi } from '@/main/baseApi';
import assertNever from 'assert-never';

import { DMS_MODULE, NAME, POLOZKY, RPZV_LOG, ZAKAZKA_LIST_FILES, PENDING_JOB_LIST, ZNAME } from './constants';

export class ZakazkaListProvider extends BaseApi {
	schemaUrl(tableName: any) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${NAME}/${POLOZKY}Schema`;
			case ZAKAZKA_LIST_FILES:
				return `/${this.area}/${NAME}/${ZAKAZKA_LIST_FILES}Schema`;
			case PENDING_JOB_LIST:
				return `/${this.area}/${ZNAME}/${PENDING_JOB_LIST}Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: any) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${NAME}/${POLOZKY}Rows`;
			case ZAKAZKA_LIST_FILES:
				return `/${this.area}/${NAME}/${ZAKAZKA_LIST_FILES}Rows`;
			case PENDING_JOB_LIST:
				return `/${this.area}/${ZNAME}/${PENDING_JOB_LIST}Rows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	tableSchemaDataUrl(tableName: any) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${NAME}/${RPZV_LOG}SchemaAndRows`;
			default:
				return assertNever(tableName as never);
		}
	}

	saveDocument(fileList: any, ZakazkaId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/SaveDocument?ZakazkaId=${ZakazkaId}`, file);
	}

	getDocuments(fileId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GeCustomerFilestDocument?fileId=${fileId}`);
	}

	deleteDocuments(fileId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/DeleteDocument?fileId=${fileId}`);
	}

	getMenaKurz() {
		return this.fetch('/Ciselniky/MenaKurz');
	}

	getMena() {
		return this.fetch('/Ciselniky/Mena');
	}

	getOrCreate(zakazkaId: number) {
		return this.fetch('/Servis/ZakazkaList/GetOrCreate', { zakazkaId });
	}

	getLastStavKm(zakazkaId: number) {
		return this.fetch(`${DMS_MODULE}/${NAME}/GetLastStavKm`, { zakazkaId });
	}

	getLatestOrderKms(vin: string) {
		return this.fetch(`${DMS_MODULE}/${NAME}/GetLatestOrderKms`, { vin });
	}

	rozsireniZakList(zakazkalistId: number | null) {
		return this.fetch(`${DMS_MODULE}/${NAME}/Rozsireni`, { zakazkalistId });
	}

	tiskZakList(data: object) {
		return this.post(`${DMS_MODULE}/${NAME}/Tisk`, data);
	}

	uzavreni(zakazkalistId: number | null) {
		return this.post(`${DMS_MODULE}/${NAME}/Uzavreni?zakazkalistId=${zakazkalistId}`);
	}

	rpzvLogSchemaAndRows(ZakazkalistId: null | number) {
		return this.fetch(`${DMS_MODULE}/${NAME}/RpzvLogSchemaAndRows`, { ZakazkalistId, wantRows: true });
	}

	sendRpzvKm(ZakazkalistId: null | number) {
		return this.post(`${DMS_MODULE}/${NAME}/RpzvSendMileage?zakazkalistId=${ZakazkalistId}`);
	}

	sendRpzvKmPhoto(fileList: any, ZakazkalistId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/RpzvSendMileagePhoto?zakazkalistId=${ZakazkalistId}`, file);
	}

	getRepeatRepairRevisit(Vozidloidi: number, odometer: number): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/VozidloCheckIn/GetRepeatRepairRevisit?VehicleId=${Vozidloidi}&odom=${odometer}`);
	}

	async onPrintTimesheet(Id: number) {
		return this.fetchPdf('/Uctenky/Reports/GetTechnicalWorkTimeSheetReport', { ZakazkaId: Id });
	}
}

export const apiProvider = new ZakazkaListProvider(DMS_MODULE, NAME);
